import * as GlobalType from './GlobalType';

export default function GlobalReducer(state, action) {
    switch (action.type) {
      /**
       * INITIALISATION
       */
      case GlobalType.INIT_ESTAB:
        return { ...state, establishment: action.payload };
      case GlobalType.INIT_LANGUAGES:
        return { ...state, languages: action.payload };
      case GlobalType.INIT_COUNTRIES:
        return { ...state, countries: action.payload };
      case GlobalType.INIT_IDENTITY_DOCUMENTS:
        return { ...state, identityDocuments: action.payload };
      case GlobalType.INIT_TRANSLATIONS:
        return { ...state, translations: action.payload };
      case GlobalType.INIT_USER:
        return { ...state, user: action.payload };
      case GlobalType.INIT_USER_ACTION_TYPES:
        return { ...state, userActionTypes: action.payload };
      case GlobalType.INIT_USER_ACTIONS:
        return { ...state, userActions: action.payload };
      case GlobalType.INIT_LEGAL_INFO:
        return { ...state, legalInfo: action.payload };
      case GlobalType.INIT_MESSAGES:
        return { ...state, messages: action.payload };
      case GlobalType.INIT_HASMDP:
        return { ...state, hasMdp: action.payload };
      case GlobalType.INIT_AUTHSTATUS:
        return { ...state, authenticationStatus: action.payload };
      case GlobalType.INIT_DISPLAY_CONTROL:
        return { ...state, displayControl: action.payload };
      case GlobalType.INIT_ESTAB_COLLECTION:
        return { ...state, establishmentCollection: action.payload };
      case GlobalType.INIT_BY_ORGA:
        return { ...state, espaceClientByOrga: action.payload };
      case GlobalType.INIT_ETAB_REF:
        return { ...state, id_etab_reference: action.payload };
      case GlobalType.INIT_MOT_CHAMBRE:
        return { ...state, affMotChambre: action.payload };
      case GlobalType.INIT_FIELD_RESIDENT_PARAM:
        return { ...state, fieldResidentParam: action.payload };
        
      
      /**
       * SETTERS
       */
      case GlobalType.SET_HEADERS:
        return { ...state, headerPage: action.payload};
      case GlobalType.SET_USER:
        return { ...state, user: action.payload};
      case GlobalType.SET_USER_ACTIONS:
        return { ...state, userActions: action.payload};
      default:
        return state;
    }
}
  